export default __webpack_public_path__ + "static/media/080_finish_soso.d8d51faa.mp4";